import React from 'react';
import PropTypes from 'prop-types';
import { AloneWrapper } from 'components';

import './congratulation-tile.scss';

export class CongratulationTile extends React.PureComponent {
  static propTypes = {
    title: PropTypes.string,
    description: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    icon: PropTypes.node,
    bottomPanel: PropTypes.node,
    //styles
    titleStyle: PropTypes.object,
    descriptionStyle: PropTypes.object,
    tileStyle: PropTypes.object,
    iconStyle: PropTypes.object,
  };

  static defaultProps = {
    title: '',
    description: '',
    icon: null,
    bottomPanel: null,
    descriptionStyle: {},
  };

  render() {
    const {
      title,
      description,
      icon,
      bottomPanel,
      descriptionStyle,
      titleStyle,
      tileStyle,
      iconStyle,
    } = this.props;

    return (
      <div className="congratulation-tile montserrat" style={{ ...tileStyle }}>
        <div className="congratulation-tile__title" style={{ ...titleStyle }}>
          {title}
        </div>
        {icon && (
          <div
            className="congratulation-tile__icon mt-20"
            style={{ ...iconStyle }}
          >
            {icon}
          </div>
        )}
        {description && (
          <div
            className="congratulation-tile__description mt-8"
            style={{ ...descriptionStyle }}
          >
            {description}
          </div>
        )}
        {bottomPanel && <div className="mt-14">{bottomPanel}</div>}
      </div>
    );
  }
}

CongratulationTile.AloneWrapper = AloneWrapper;
